import { doc, updateDoc, serverTimestamp, Timestamp } from 'firebase/firestore'
import { db } from '@/lib/firebase'

export async function completeBooking(
  bookingId: string,
  data: {
    status: 'completed' | 'no_show'
    finalPrice?: number
    actualDate?: Date
    notes?: string
  }
): Promise<void> {
  try {
    const bookingRef = doc(db, 'bookings', bookingId)
    
    // Build the bookingCompleteForm object
    const bookingCompleteForm: any = {
      completedAt: serverTimestamp(),
      result: data.status
    }
    
    // Only add these fields if status is completed
    if (data.status === 'completed') {
      if (data.finalPrice !== undefined) {
        bookingCompleteForm.finalPrice = data.finalPrice
      }
      if (data.actualDate) {
        bookingCompleteForm.actualDate = Timestamp.fromDate(data.actualDate)
      }
    }
    
    // Add notes if provided (for both completed and no_show)
    if (data.notes) {
      bookingCompleteForm.notes = data.notes
    }
    
    // Update the booking
    await updateDoc(bookingRef, {
      status: 'completed',
      updatedAt: serverTimestamp(),
      bookingCompleteForm
    })
    
    console.log('[completeBooking] Successfully updated booking:', bookingId)
  } catch (error) {
    console.error('[completeBooking] Error updating booking:', error)
    throw error
  }
}

